import * as React from "react";
import {IMapContext} from "../../interfaces/map.interfaces";

const MapComponentContext = React.createContext(null as IMapContext | null);

export default MapComponentContext;
